import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

function AboutModal({ open, onOpenChange }) {
  const [aboutContent, setAboutContent] = useState('');

  useEffect(() => {
    // Fetch About.md when component mounts
    fetch('/About.md')
      .then(response => response.text())
      .then(text => setAboutContent(text))
      .catch(err => console.error('Failed to load About.md:', err));
  }, []);

  // Simple markdown-like parsing for display
  const parseMarkdown = (text) => {
    const lines = text.split('\n');
    const elements = [];
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      
      if (line.startsWith('# ')) {
        elements.push(<h1 key={i} className="text-3xl font-bold text-gray-900 mb-4 mt-6">{line.substring(2)}</h1>);
      } else if (line.startsWith('## ')) {
        elements.push(<h2 key={i} className="text-2xl font-bold text-gray-800 mb-3 mt-5">{line.substring(3)}</h2>);
      } else if (line.startsWith('### ')) {
        elements.push(<h3 key={i} className="text-xl font-semibold text-gray-700 mb-2 mt-4">{line.substring(4)}</h3>);
      } else if (line.trim() === '') {
        elements.push(<div key={i} className="h-2"></div>);
      } else {
        elements.push(<p key={i} className="text-gray-700 leading-relaxed mb-2">{line}</p>);
      }
    }
    
    return elements;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="about-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl">About Speaker's Bureau</DialogTitle>
        </DialogHeader>
        <div className="prose prose-sm max-w-none">
          {aboutContent ? parseMarkdown(aboutContent) : (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#005DAA]"></div>
              <p className="mt-2 text-gray-600">Loading...</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default AboutModal;
